export default __webpack_public_path__ + "static/media/stamper.bd5c68e1.png";